import React from "react";
import {Stack, Typography} from "@mui/material";
import {Link} from "react-router-dom";

export function NotFoundPage() {
	return <Stack alignItems={"center"}>
		<Typography variant={"h1"}>404</Typography>
		<div><img src={"/images/not-found-looping.gif"} alt={"not-found"}/></div>
		<div><p>The page you requested cannot be found, please review the url or go to the <Link to={"/"}>home
			page</Link>.</p></div>
	</Stack>;
}
